import MapPage from "@/pages/map";
import type { RouteConfig } from "../models/types";

export const mapRoutes: RouteConfig[] = [
	{
		path: "/map/",
		element: <MapPage />,
	},
	{
		path: "/map/:AssetIdParam",
		element: <MapPage />,
	},
];
